import type { GetProductQuery } from '$gql/storefront/operations';
import { getContext, setContext } from 'svelte';

export const setPDPProductContext = (product: NonNullable<GetProductQuery['product']>) => {
  return setContext('pdp-product', product);
};

export const getPDPProductContext = () => {
  return getContext<NonNullable<GetProductQuery['product']> | undefined>('pdp-product');
};
